import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getCrmPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/reseni/crm",
		[Locale.en]: "/solutions/crm",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
